import React, {useEffect, useState} from "react";
import SingleFileUpload from "../SingleFileUpload/SingleFileUpload";
import {Checkbox} from "primereact/checkbox";
import {Button} from "primereact/button";
import {downloadBdsValidationReport} from "../../../api/file/download-service";

export default function AttachBDSFiles({
                                           onCheckboxChange,
                                           isChecked,
                                           onBDSFileChange,
                                           validateBdsFile,
                                           dataCollection,
                                           BDSFiles,
                                           BDSFilesValidationResult,
                                           disabled,
                                           initTopologyFile,
                                           initEquipementFile
                                       }) {
    const bdsFilesExtensions = [
        ".ttl", ".xml"
    ]

    const handleCheckBoxChange = (e) => {
        onCheckboxChange && onCheckboxChange(e.checked);
    }


    const handleBDSFileChange = (fileType) => (file, isNewFileSelected) => {
        onBDSFileChange && onBDSFileChange(fileType, file, isNewFileSelected);
    };


    const [isValidateButtonDisabled, setIsValidateButtonDisabled] = useState(true)

    useEffect(() => {
        setIsValidateButtonDisabled(
            dataCollection.model === "" ||
            BDSFiles.topology === null ||
            BDSFiles.equipment === null ||
            BDSFilesValidationResult.isValidating)
    }, [dataCollection.model, BDSFiles.topology, BDSFiles.equipment]);

    function getTooltipMessage() {
        switch (true) {
            case dataCollection.model === '' :
                return "PEMMDB Version is mandatory "
            case BDSFiles.topology === null || BDSFiles.equipment === null:
                return "Equipment and Topology files are mandatory"
            case BDSFilesValidationResult.status === "REPORT_INVALID":
                return "Boundary points files need to be validated"
            case BDSFilesValidationResult.status === "INPUT_FILES_INVALID":
                return "Wrong uploaded Boundary points files"
            default:
                return ""
        }
    }

    function downloadReport() {
        downloadBdsValidationReport("report.html", {
            filename: "report.html",
            filePath: BDSFilesValidationResult.reportPath
        })
            .then((_) => {

            })
    }

    return (
        <div>
            <Checkbox
                inputId="BdsAttachement"
                checked={isChecked}
                onChange={handleCheckBoxChange}
                disabled={disabled}
            />
            <label htmlFor="BdsAttachement" className="ml-2">This is an IGM</label>
            <div className="col-3"/>
            {isChecked && <div>


                <div style={{display: "flex", gap: "0.15rem", flexWrap: "wrap"}}>
                    <div style={{flex: "1 1 200px", minWidth: "200px"}}>

                        <SingleFileUpload
                            buttonLabel="Upload equipment file"
                            onFileChange={handleBDSFileChange("equipment")}
                            disabled={dataCollection.model === '' || BDSFilesValidationResult.isValidating}
                            disableDeleteButton={BDSFilesValidationResult.isValidating}
                            accept={bdsFilesExtensions.join(",")}
                            initialFile={initEquipementFile ? initEquipementFile : null}
                        />
                    </div>
                    <div style={{flex: "1 200px", minWidth: "200px"}}>
                        <SingleFileUpload
                            disabled={dataCollection.model === '' || BDSFilesValidationResult.isValidating}
                            disableDeleteButton={BDSFilesValidationResult.isValidating}
                            buttonLabel="Upload topology file"
                            onFileChange={handleBDSFileChange("topology")}
                            accept={bdsFilesExtensions.join(",")}
                            initialFile={initTopologyFile ? initTopologyFile : null}
                        />
                    </div>
                    <div>
                        {(BDSFilesValidationResult.status === null ||
                            BDSFilesValidationResult.status === "INPUT_FILES_INVALID"
                        ) && <Button
                            onClick={() => {
                                validateBdsFile()
                            }}
                            type={"button"}
                            style={{background: "#487c84", border: "hidden"}}
                            className={"p-button-md"}
                            disabled={isValidateButtonDisabled}
                            label={"Validate"}
                            loading={BDSFilesValidationResult.isValidating}
                        />}

                        {BDSFilesValidationResult.status === "REPORT_VALID" && <Button
                            severity={"success"}
                            type={"button"}
                            disabled={true}
                            style={{border: "hidden"}}
                            className={"p-button-md"}
                            label={"Files are valid"}
                        />}

                        {BDSFilesValidationResult.status === "REPORT_INVALID" && <Button
                            onClick={() => {
                                downloadReport()
                            }}
                            severity={"danger"}
                            type={"button"}
                            style={{border: "hidden"}}
                            className={"p-button-md"}
                            label={"Download Report"}
                        />}
                    </div>
                </div>
                {
                    !(BDSFilesValidationResult.status === true) &&
                    <p style={{color: "red", margin: 0}}>{getTooltipMessage()}</p>}
            </div>}
        </div>
    );
}
